/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */

import React from 'react';
import HeadTittle from '../../../../../components/HeadTittle';
import routes from '../../../../../Routes/routes';
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {AddIcon} from "../../../../../components/buttons/IconButtons";
import {CommonContractorCreateUpdateApp} from "../../Functionality/ContractorCreateUpdateFlows/CommonContractorCreateUpdateApp";
import ManagerFields from "../ContractorCreateUpdateFlows/ManagerFields";
import {ContractorUpdateEmployeeApp} from "../../Functionality/EmployeeCreateUpdateFlows/ContractorUpdateEmployeeApp";
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../../../components/StepperTabs/StepTab';
import {ACTION_MODEL} from '../../../../../Helpers/ActionModel';
import {FILE_TYPE} from '../../../../../Helpers/fileType';
import {SUGGESTION_MODE_OPTION} from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import CustomPhotoPicker from '../../../../../components/PhotoPicker/CustomPhotoPicker';
import CopySecretModal from '../../../Company/Employees/Modal/CopySecretModal';

const ContractorCreateEmployee = () => {
    const props = CommonContractorCreateUpdateApp();

    const {
        t,
        permission,
        params,
        dispatch,
        emptyFields,
        setEmptyFields,
        isValidEmail,
        isValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        isValidDocumentId,
        setIsValidDocumentId,
        userInfoStatusList,
        photoPicker,
        setPhotoPicker,
        secretKey,
        setSecretKey,
        secretModal,
        setSecretModal,
        handleDateChange,
        handleEmailChange,
        handlePasswordChange,
        handlePhoneNumberChange,
        validateEmail,
        validatePhone,
    }  = props;

    const {
        user,
        setUser,
        FormHandler,
        steps,
        activeStep, setActiveStep,
        handleStepChange
    } = ContractorUpdateEmployeeApp({
        t,
        permission,
        params,
        dispatch,
        setEmptyFields,
        isValidEmail,
        isValidPhoneNumber,
        isValidDob,
        photoPicker,
        setPhotoPicker,
        setSecretModal,
        setSecretKey
    });

    return (
        <>
            <HeadTittle
                link={routes.contractor.searchEmployee}
                name={t("update")}
            >
                <ButtonAction
                    id={'btn_cue_update'}
                    name={'update'}
                    className={'btn-icon-edit'}
                    Icon={AddIcon}
                    onClick={() => {
                        validateEmail(user.email);
                        validatePhone(user.phoneNumber);
                        FormHandler();
                    }}
                />
            </HeadTittle>

            <StepperTabs id={user?.id} steps={steps} activeStep={activeStep}
                         isStepOptional={() => { }} setActiveStep={setActiveStep}
                         handleStepChange={handleStepChange} >
                <StepTab index={0} activeStep={activeStep} normalHeight={true}>
                    <ManagerFields
                        title={"user_data"}
                        user={user}
                        setUser={setUser}
                        emptyFields={emptyFields}
                        isValidDocumentId={isValidDocumentId}
                        setIsValidDocumentId={setIsValidDocumentId}
                        isValidEmail={isValidEmail}
                        isValidPhoneNumber={isValidPhoneNumber}
                        isValidDob={isValidDob}
                        setIsValidDob={setIsValidDob}
                        handleEmailChange={handleEmailChange}
                        handlePasswordChange={handlePasswordChange}
                        handlePhoneNumberChange={handlePhoneNumberChange}
                        handleDateChange={handleDateChange}
                        statusList={userInfoStatusList}
                    />
                </StepTab>
                <StepTab index={1} activeStep={activeStep} normalHeight={true}>
                    <CustomPhotoPicker
                        id='fp_ce_update_photo_profile'
                        photoPicker={photoPicker}
                        setPhotoPicker={setPhotoPicker}
                        actionModel={ACTION_MODEL.UPDATE}
                        accept={{ ...FILE_TYPE.IMAGE_FACE_VALIDATION }}
                        showBtnCamera={true}
                        validateFace={true}
                        classWith={'w-400px'}
                        showPreview={true}
                        titleModalEdit='update_photography'
                        typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE} // It is required if showBtnCamera is true
                    />
                </StepTab>
            </StepperTabs>

            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setUser}
                onHide={() => {}}
                closeText={"close"}
            />

        </>
    );
};

export default ContractorCreateEmployee;
